import React from 'react';

export default class OnOffCheckboxField extends React.Component {
  static defaultProps = {
    onChange: () => {},
    value: null,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className='inputCheckBoxContainer'>
        <input
          className='inputCheckBox'
          type='checkbox'
          onClick={(e) => {
            const newValue = !this.props.value;
            this.props.onChange(newValue);
          }}
          checked={Boolean(this.props.value)}
          onChange={() => {}}
        />
      </div>
    );
  }
}
